export * from './thank-you.component';
